import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-up",
  "use": "various-arrow-up-usage",
  "viewBox": "0 0 14 38",
  "content": "<symbol viewBox=\"0 0 14 38\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-up\"><path d=\"M8 14v24H6V14H0L7 0l7 14H8z\" fill=\"#e3000f\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol